// Org IDs where Strategy Maps is hidden (default to Projects page)
export const ORG_HIDE_STRATEGY_MAPS = "org_2tBzvO2slBraLJpuIOy0oczzvGW";

// Entity type icons
import { BsLayersFill } from 'react-icons/bs';
import PuzzleIcon from '../components/Icons/PuzzleIcon';
import SquareCheckIcon from '../components/Icons/SquareCheckIcon';
import BookIcon from '../components/Icons/BookIcon';
import { IoLayers, IoBugOutline } from "react-icons/io5";
import { GiSpikesHalf } from "react-icons/gi";
import { HiOutlineCog, HiOutlineViewBoards } from 'react-icons/hi';



export const colorWheelColors = {
  red: '#dc2626',          // Hue ≈ 0
  orange: '#ea580c',       // Hue ≈ 20
  amber: '#f59e0b',        // Hue ≈ 40
  forestGreen: '#16a34a',  // Hue ≈ 142
  green: '#059669',        // Hue ≈ 160
  emerald: '#10b981',      // Hue ≈ 165
  teal: '#0d9488',         // Hue ≈ 174
  cyan: '#06b6d4',         // Hue ≈ 189
  skyBlue: '#0ea5e9',      // Hue ≈ 199
  blue: '#3b82f6',         // Hue ≈ 217
  primaryBlue: '#1d64f3',  // Hue ≈ 222
  deepBlue: '#1e40af',     // Hue ≈ 226
  indigo: '#6366f1',       // Hue ≈ 240
  violet: '#8b5cf6',       // Hue ≈ 265
  purple: '#7c3aed',       // Hue ≈ 272
  slate: '#64748b',        // Hue ≈ 210 (low saturation)
  coolGray: '#374151',     // Hue ≈ 220 (very low saturation)
  gray: '#6b7280'          // Hue ≈ 220 (very low saturation)
};

export const workUnitsTableHeaders = [
  {
    value: "project_name",
    label: "Work Item"
  },
  {
    value: "status",
    label: "Status"
  },
  {
    value: "progress",
    label: "Progress"
  },
  {
    value: "priority",
    label: "Priority"
  },
  {
    value: "total_cost",
    label: "Total Cost"
  },
  {
    value: "timeline",
    label: "Timeline"
  },
  {
    value: "modified_at",
    label: "Last Modified"
  },
  {
    value: "members",
    label: "Members"
  },
  {
    value: "integration_status",
    label: "Integration Status"
  },
  {
    value: "stage",
    label: "Stage"
  },
  {
    value: "created_at",
    label: "Created On"
  },
  {
    value: "created_by",
    label: "Created By"
  },
  {
    value: "action",
    label: "Action"
  }
]

/**
 * Entity Type Styling Configuration
 * Used for displaying entity types with consistent icons and colors across the app
 */

export const entityTypeStyles = {
  strategy_map: {
    label: 'STRATEGY MAP',
    icon: HiOutlineViewBoards,
    bgClass: 'bg-violet-500/15',

    labelClass: "text-sky-600 dark:text-sky-400",
    iconClass: "text-sky-800 scale-125 dark:text-sky-300",
    chipClass: "bg-sky-100 text-sky-800 dark:bg-sky-900/30 dark:text-sky-300",
  },
  epic_advanced: {
    label: 'EPIC',
    icon: IoLayers,
    bgClass: 'bg-violet-500/15',
    iconClass: 'text-violet-400 dark:text-violet-300',
    labelClass: 'text-violet-400/80 dark:text-violet-300/80',
    chipClass: "bg-violet-100 text-violet-800 dark:bg-violet-900/30 dark:text-violet-300",
  },
  epic_normal: {
    label: 'EPIC',
    icon: BsLayersFill,
    bgClass: 'bg-violet-500/15',
    iconClass: 'text-violet-400 dark:text-violet-300',
    labelClass: 'text-violet-400/80 dark:text-violet-300/80',
    chipClass: "bg-violet-100 text-violet-800 dark:bg-violet-900/30 dark:text-violet-300",
  },
  feature: {
    label: 'FEATURE',
    icon: PuzzleIcon,
    bgClass: 'bg-sky-500/15',
    iconClass: 'text-sky-400 dark:text-sky-300',
    labelClass: 'text-sky-400/80 dark:text-sky-300/80',
    chipClass: "bg-sky-100 text-sky-800 dark:bg-sky-900/30 dark:text-sky-300",
  },
  task: {
    label: 'TASK',
    icon: SquareCheckIcon,
    bgClass: 'bg-amber-500/15',
    iconClass: 'text-amber-500 dark:text-amber-300',
    labelClass: 'text-amber-500 dark:text-amber-300/80',
    chipClass: "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300",
  },
  settings: {
    label: 'SETTINGS',
    icon: HiOutlineCog,
    bgClass: 'bg-gray-500/15',
    iconClass: 'text-gray-500 dark:text-gray-300',
    labelClass: 'text-gray-500 dark:text-gray-300/80',
    chipClass: "bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-300",
  },
  work_unit: {
    label: 'WORK UNIT',
    icon: BsLayersFill,
    bgClass: 'bg-gray-500/15',
    iconClass: 'text-gray-400 dark:text-gray-300',
    labelClass: 'text-gray-400/80 dark:text-gray-300/80',
    chipClass: "bg-gray-100 text-gray-800 dark:bg-gray-700/50 dark:text-gray-300",
  },
  bug: {
    label: 'BUG',
    icon: IoBugOutline,
    bgClass: 'bg-red-500/15',
    iconClass: 'text-red-400 dark:text-red-300',
    labelClass: 'text-red-400/80 dark:text-red-300/80',
    chipClass: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300",
  },
  user_story: {
    label: 'USER STORY',
    icon: BookIcon,
    bgClass: 'bg-emerald-500/15',
    iconClass: 'text-emerald-400 dark:text-emerald-300',
    labelClass: 'text-emerald-400/80 dark:text-emerald-300/80',
    chipClass: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300",
  },
  story: {
    label: 'STORY',
    icon: BookIcon,
    bgClass: 'bg-emerald-500/15',
    iconClass: 'text-emerald-400 dark:text-emerald-300',
    labelClass: 'text-emerald-400/80 dark:text-emerald-300/80',
    chipClass: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300",
  },
  spike: {
    label: 'SPIKE',
    icon: GiSpikesHalf,
    bgClass: 'bg-orange-500/15',
    iconClass: 'text-orange-400 dark:text-orange-300',
    labelClass: 'text-orange-400/80 dark:text-orange-300/80',
    chipClass: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300",
  },
};

export type EntityTypeKey = keyof typeof entityTypeStyles;

/**
 * Get entity type key based on entity_type and type (roadmap/project)
 */
export const getEntityTypeKey = (entityType?: string, type?: string): EntityTypeKey => {
  const lowerEntityType = entityType?.toLowerCase() || '';
  const lowerType = type?.toLowerCase() || '';

  if(entityType =="strategy_map") return "strategy_map";
  if (lowerEntityType === 'epic') {
    return lowerType === 'roadmap' ? 'epic_advanced' : 'epic_normal';
  }
  if (lowerEntityType === 'feature') return 'feature';
  if (lowerEntityType === 'task') return 'task';
  if (lowerEntityType === 'bug') return 'bug';
  if (lowerEntityType === 'user_story' || lowerEntityType === 'user story') return 'user_story';
  if (lowerEntityType === 'story' || lowerEntityType === 'normal story') return 'story';
  if (lowerEntityType === 'spike') return 'spike';
  if (entityType === 'settings') return 'settings';
  return 'work_unit';
};


export const DEFAULT_MENTION_SEARCH_CACHE= {
  all: { items: [], searchTerm: '', page: 0, totalCount: 0, hasMore: false },
  project: { items: [], searchTerm: '', page: 0, totalCount: 0, hasMore: false },
  strategymap: { items: [], searchTerm: '', page: 0, totalCount: 0, hasMore: false },
  team: { items: [], searchTerm: '', page: 0, totalCount: 0, hasMore: false },
  resource: { items: [], searchTerm: '', page: 0, totalCount: 0, hasMore: false },
  epic: { items: [], searchTerm: '', page: 0, totalCount: 0, hasMore: false },
  feature: { items: [], searchTerm: '', page: 0, totalCount: 0, hasMore: false },
  roadmap: { items: [], searchTerm: '', page: 0, totalCount: 0, hasMore: false },
}


export const GENERAL_TYPES = {
  epic: "Epics",
  container_epic: "Advanced Epics",
  executing_epic: "Normal Epics",
  all: "Epics and Features",
  epic_advanced: "Epic",
  epic_normal: "Epic",
  feature: "Feature"
}

export enum ComponentPage {
  STRATEGY_MAPS = 'strategy_maps',
  WORK_ITEMS = 'work_items',
  PEOPLE = 'people',
  NOTIFICATION = 'notification',
  SETTINGS = 'settings',
  EPIC = 'epic',
  FEATURE = 'feature',
}

export const ROUTE_TO_COMPONENT: Record<string, ComponentPage[]> = {
  '/': [ComponentPage.WORK_ITEMS],
  '/workitems': [ComponentPage.WORK_ITEMS],
  '/strategymaps': [ComponentPage.STRATEGY_MAPS],
  '/projects': [ComponentPage.EPIC, ComponentPage.FEATURE],
  '/roadmaps': [ComponentPage.EPIC],
  '/resources': [ComponentPage.PEOPLE],
  '/notification': [ComponentPage.NOTIFICATION],
  '/settings': [ComponentPage.SETTINGS],
}